import React, { useState, useLayoutEffect } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { css, Box } from 'theme-ui'
import Reveal from '@solid-ui-components/Reveal'

const styles = {
  notResponsive: {
    display: 'block',
    '@media (max-width: 991px)': {
      display: 'none',
    },
  },
  responsive: {
    display: 'none',
    '@media (max-width: 991px)': {
      display: 'block',
    },
  }
}

const ImageComponent = ({ image, sx, ...props }) => {
  if (!image?.src) return null

  // SVG Asset
  const isSVG = image.src.extension === 'svg' || image.src.extension === 'png'
  if (isSVG) {
    return (
      <img
        src={image.src.publicURL}
        style={{
          width: image.width || `100%`,
          maxWidth: image.maxWidth || `none`
        }}
        {...props}
      />
    )
  }

  // Image Asset
  const imageData = getImage(image.src)
  if (imageData) {
    return (
      <GatsbyImage
        image={imageData}
        alt={image.alt}
        css={css({
          verticalAlign: `middle`,
          borderStyle: image.border ? `solid` : `none`,
          borderWidth: image.border || 0,
          borderColor: `white`,
          boxShadow: image.shadow || `unset`,
          borderRadius: image.radius || `unset`,
          ...sx
        })}
        {...props}
      />
      )
  }

  return null
}

const ContentImages = ({
  content: { images },
  reverse,
  imagePosition,
  objectPosition,
  imageFit,
  imageEffect,
  loading,
  sx
}) => {

  return images ? (
    <>
      <Reveal
        effect={imageEffect || (reverse ? 'fadeInRight' : 'fadeInLeft')}
        css={css({
          textAlign:
            imagePosition === 'center'
              ? 'center'
              : reverse
              ? `right`
              : undefined
        })}
      >
        <Box sx={styles.notResponsive}>
          <ImageComponent
            image={images[0]}
            loading={loading}
            objectFit={imageFit}
            objectPosition={objectPosition}
            sx={sx}
          />
        </Box>
        <Box sx={styles.responsive}>
          <ImageComponent
            image={images[images.length - 1]}
            loading={loading}
            objectFit={imageFit}
            objectPosition={objectPosition}
            sx={sx}
          />
        </Box>
      </Reveal>
      {images?.slice(1, images.length - 1 )?.map(
        (image, index) =>
          image.src && (
            <Reveal
              key={`item-${index}`}
              effect={image.effects[0] || undefined}
              delay={0.5}
              css={css({
                ...image.position,
                position: `absolute`,
                minWidth: '50px',
                display: ['none', 'none', 'none', 'block'],
              })}
            >
              <Reveal
                effect={image.effects[1] || undefined}
                style={{ backfaceVisibility: `hidden` }}
              >
                <ImageComponent image={image} loading={loading} />
              </Reveal>
            </Reveal>
          )
      )}
    </>
  ) : null
}

ContentImages.defaultProps = {
  loading: 'lazy'
}

export default ContentImages
